import React from 'react'

const ParabolLogoSVG = React.memo(() => {
  return (
    React.createElement('svg', {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      fillRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: "2",
      clipRule: "evenodd",
      viewBox: "0 0 24 24"   ,}

      , React.createElement('path', {
        fill: "#FD6157",
        fillRule: "nonzero",
        d: "M17 24.801c-1.062 0-2.11-.051-3.13-.147 3.891 4.264 8.298 6.267 11.134 4.629 1.806-1.044 2.648-3.381 2.577-6.362a28.65 28.65 0 01-10.577 1.88M17 6.051c1.063 0 2.11.05 3.13.147-3.886-4.263-8.293-6.266-11.129-4.629-1.806 1.044-2.648 3.38-2.577 6.362a28.643 28.643 0 0110.577-1.88"                         ,
        transform: "translate(-.278 .859) scale(.72222)"  ,}
      )
      , React.createElement('path', {
        fill: "#55C0CF",
        fillRule: "nonzero",
        d: "M28.779 10.014a28.635 28.635 0 01-3.66 10.099 33.34 33.34 0 01-1.695 2.642C29.061 21.517 33 18.703 33 15.426c0-2.087-1.601-3.988-4.221-5.417M8.881 10.74a33.137 33.137 0 011.695-2.641C4.938 9.336 1 12.152 1 15.427c0 2.088 1.6 3.988 4.22 5.417a28.674 28.674 0 013.661-10.101"                                ,
        transform: "translate(-.278 .859) scale(.72222)"  ,}
      )
      , React.createElement('path', {
        fill: "#A06BD6",
        fillRule: "nonzero",
        d: "M25.118 10.738a35.35 35.35 0 011.445 2.788C28.306 8.023 27.836 3.207 25 1.57c-1.806-1.045-4.256-.608-6.801.95a28.624 28.624 0 016.919 8.219M8.881 20.114a35.337 35.337 0 01-1.444-2.788c-1.748 5.501-1.278 10.319 1.559 11.957 1.806 1.045 4.256.608 6.801-.95a28.624 28.624 0 01-6.919-8.219"                             ,
        transform: "translate(-.278 .859) scale(.72222)"  ,}
      )
    )
  )
})

export default ParabolLogoSVG
